export default __webpack_public_path__ + "static/media/laundry1-beforeA-1024w.3e63fbf8.png";